import { takeLatest, put, call } from 'redux-saga/effects';

import { listUnidadeMedidaConversaoCadastro } from '../service';
import {
  TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO,
  TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING,
  TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS,
  TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListUnidadeMedidaConversaoCadastro(action) {
  yield put({ type: TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING })

  try {
    const table = yield call(listUnidadeMedidaConversaoCadastro, action.args)
    yield put({ type: TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListUnidadeMedidaConversaoCadastro() {
  yield takeLatest(TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO, sagaListUnidadeMedidaConversaoCadastro)
}